import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

const clientInsightsStyles = {
  'client-insights': {
    width: '100%',
  },

  'client-insights__box--flex-row': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 2,
    marginTop: '-40px'
  },

  'client-insights__custom-range-box': {
    border: '1px solid #D9D9D9',
    borderRadius: '4px',
    padding: '2px',
    gap: '4px',
    display: 'flex',
    alignItems: 'center',
    marginTop: '4px',
    marginLeft: 'auto', // Moves it to the end of the flex container
  },

  'client-insights__date-picker-text-field': (theme: Theme): SxProps => ({
    sx: {
      marginLeft: '2px',
      marginRight: '2px',
      [theme.breakpoints.down('lg')]: {
        // width: "200px",
      },
      '& .MuiInputBase-root': {
        minWidth: '180px',
        maxWidth: '180px',
        height: '38px',
        fontSize: '16px',
        fontWeight: 600,
      },
    },
  }),

  'client-insights__separator-text': {
    marginX: '8px',
    fontSize: '16px',
    fontWeight: 600,
  },

  'client-insights__chart-container': {
    padding: '25px',
    border: '2px solid #DFDFDF',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '10px',
    marginTop: '10px',
  },

  'Toogle__switch-container': {
    height:'60px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    position: 'relative',
    marginRight: 1,
  },

  'Toogle__switch-typography': {
    marginRight: '8px',
    fontFamily: 'var(--font-family)',
    fontSize:"13px",
    height:"16px",
    fontWeight:"500",
    lineHeight:"16px"
  },

  'Toogle__switch': (Rated: boolean): SxProps => ({
    width: 40,
    height: 20,
    padding: 0,
    marginRight: 1,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      transform: Rated ? 'translateX(22px)' : 'translateX(1px)', // Thumb flush with edges
      transition: 'all 300ms ease',
      '&.Mui-checked': {
        transform: 'translateX(20px)', // Adjust for right spacing
      },
      '&.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#B902CA', // Track color for Scored
        opacity: 1,
      },
    },
    '& .MuiSwitch-thumb': {
      width: 16,
      height: 16,
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
      backgroundColor: '#fff', // Thumb color
      marginTop: '1.9px', // Margin on top
      marginRight: '5px', // Margin on right
      marginBottom: '0px', // Margin on bottom
      marginLeft: '2px',
    },
    '& .MuiSwitch-track': {
      borderRadius: 10,
      backgroundColor: '#ccc', // Track color for Non Scored
      opacity: 1,
      transition: 'background-color 300ms ease',
    },
  }),
};

export default clientInsightsStyles;
